var map = {
	"./de.json": 448202,
	"./en.json": 624764,
	"./es.json": 479038,
	"./fr.json": 833942,
	"./it.json": 559094,
	"./ja.json": 273956,
	"./ko.json": 432135,
	"./pl.json": 972929,
	"./pt.json": 170627,
	"./ru.json": 954106,
	"./uk.json": 546295
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 721807;